import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logininfo: {
      loginBloon: false,
      name: ''
    },
    // 是否展示登录框
    showLogin: false,
    // 商标列表q的参数
    brandQ: '',
    // 商标列表排序的参数
    brandSort: ''
  },
  getters: {
  },
  mutations: {
    logoChange (state, loginkeyarr) {
      state.logininfo.loginBloon = loginkeyarr.loginBloon
      state.logininfo.name = loginkeyarr.frimName
    },
    // 展示登录框的方法
    changeShowLogin (state, status) {
      state.showLogin = status
    },
    // 传商标q的参数
    sendBrandQ(state, q) {
      console.log(q, 'q')
      state.brandQ = q
    },
    sendBrandSort(state, sort) {
      state.brandSort = sort
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage // 存储方式改为sessionStorage
  }
  )]
})
